// AccountDashboard.jsx
import React, { useState } from 'react';
import { Box, Tabs, Tab, Paper, Grid } from '@mui/material';
// In AccountDashboard.jsx
import {
    AttachMoney as MoneyIcon,
    Savings as SavingsIcon,
    AccountBalance as BalanceIcon,
    Receipt as TransactionIcon
  } from '@mui/icons-material';
import RevenueOverview from './RevenueOverview';
import SavingsAccounts from './SavingsAccounts';
import FinancialReports from './FinancialReports';
import TransactionManagement from './TransactionManagement';
import DashboardFilters from './DashboardFilters';

const AccountDashboard = () => {
  const [tabValue, setTabValue] = useState(0);
  const [filters, setFilters] = useState({
    dateRange: {
      start: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      end: new Date()
    },
    timeRange: 'month'
  });

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  return (
    <Box sx={{ p: 3 }}>
      <DashboardFilters filters={filters} onFilterChange={handleFilterChange} />
      
      <Tabs value={tabValue} onChange={handleTabChange} sx={{ mb: 3 }}>
        <Tab label="Revenue Overview" icon={<MoneyIcon />} />
        <Tab label="Savings Accounts" icon={<SavingsIcon />} />
        <Tab label="Financial Reports" icon={<BalanceIcon />} />
        <Tab label="Transactions" icon={<TransactionIcon />} />
      </Tabs>

      {tabValue === 0 && <RevenueOverview filters={filters} />}
      {tabValue === 1 && <SavingsAccounts filters={filters} />}
      {tabValue === 2 && <FinancialReports filters={filters} />}
      {tabValue === 3 && <TransactionManagement filters={filters} />}
    </Box>
  );
};

export default AccountDashboard;